import { getAmplitudeInstance } from '../amplitudeHelpers';
import FeedbackProvided from '../enums/FeedbackProvided';

type logAskAllTrailsFeedbackRatedParams = {
  feedback?: FeedbackProvided;
  query_id?: string;
  session_id?: string;
};

/**
 * User presses thumbs up or thumbs down on an Ask AllTrails response. Logged on the press, whether or not the user goes on to submit written feedback, so this is the source of truth for thumbs up and thumbs down counts.
 * @param params - Attributes to log with the amplitude event
 * @param params.feedback - Binary feedback on the response. Use helpful or not helpful.
 * @param params.query_id - Unique id of the query the rating applies to.
 * @param params.session_id - Unique id for a continuous Ask AllTrails session.
 */
const logAskAllTrailsFeedbackRated = ({ feedback, query_id, session_id }: logAskAllTrailsFeedbackRatedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('ask all trails feedback rated', { feedback, 'query id': query_id, 'session id': session_id }, callback);
};

export default logAskAllTrailsFeedbackRated;
